export default __webpack_public_path__ + "static/media/plus_dark.5647caed.svg";